export enum ApplyStep {
    PROFILE = 'profile',
    VALIDATION = 'validation',
    MEMBERSHIP = 'membership',
    PAYMENT = 'payment',
    FINISHED = 'finished',
}

export const DEFAULT_FLOW = 'regular'
export const DEFAULT_LAYOUT = 'classic'
